import { TitleType } from 'api';

export const getTitleTypeName = (title: TitleType): string => {
  const titleNames: Record<TitleType, string> = {
    [TitleType.Dr]: 'Dr',
    [TitleType.Ms]: 'Ms',
    [TitleType.Miss]: 'Miss',
    [TitleType.Mrs]: 'Mrs',
    [TitleType.Mr]: 'Mr',
    [TitleType.Prof]: 'Prof',
    [TitleType.PhD]: 'PhD',
  };
  return titleNames[title] ?? '-';
};
